/**
 * Utility functions for extracting and formatting advance and deposit details
 * from order objects (Reservation deposits, Pre-order advances, Direct advances).
 */

export const getOrderAdvanceDetails = (order) => {
  if (!order) {
    return {
      hasAdvance: false,
      advanceAmount: 0,
      advanceType: null,
      label: "",
      shortLabel: "",
      isPaid: false,
      method: "",
      provider: "",
      uniqueId: "",
      tableName: "",
    };
  }

  // 1. Resolve Table Name (supporting single table object or tables array)
  const tableName =
    order?.reservation?.table?.name ||
    order?.reservation?.tables?.[0]?.name ||
    (Array.isArray(order?.reservation?.tables) && order.reservation.tables.length > 0
      ? order.reservation.tables.map((t) => t.name).filter(Boolean).join(", ")
      : "") ||
    order?.table?.name ||
    "";

  // 2. Check Reservation Advance Deposit
  if (order?.reservation) {
    const res = order.reservation;
    const rawAdvance = Number(res.advance || res.deposit_amount || 0);
    const isPaid =
      res.is_deposit_paid === 1 ||
      res.is_deposit_paid === true ||
      res.is_deposit_paid === "1" ||
      res.deposit_payment_info?.status === "paid" ||
      res.deposit_status === "paid" ||
      res.status === "confirmed";

    const paymentMethodRaw =
      res.deposit_payment_info?.payment_method ||
      res.deposit_payment_info?.method ||
      res.payment_method ||
      "";
    const paymentMethod = paymentMethodRaw
      ? paymentMethodRaw.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())
      : "Deposit";
    const provider = res.deposit_payment_info?.provider || "";
    const uniqueId = res.unique_id || (res.id ? `#${res.id}` : "");

    if (rawAdvance > 0) {
      return {
        hasAdvance: true,
        advanceAmount: rawAdvance,
        advanceType: "reservation",
        label: `Reservation Deposit${paymentMethod ? ` (${paymentMethod})` : ""}`,
        shortLabel: "Reservation Deposit",
        isPaid,
        method: paymentMethod,
        provider,
        uniqueId,
        tableName,
      };
    }
  }

  // 3. Check Pre-order Advance
  if (order?.pre_order) {
    const po = order.pre_order;
    const rawAdvance = Number(po.advance_amount || 0);
    const isPaid =
      po.status === "confirmed" ||
      order.payment_status === "paid" ||
      po.payment_method !== "pay_by_link";

    const paymentMethodRaw = po.payment_method || "";
    const paymentMethod = paymentMethodRaw
      ? paymentMethodRaw.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())
      : "Advance";

    if (rawAdvance > 0) {
      return {
        hasAdvance: true,
        advanceAmount: rawAdvance,
        advanceType: "pre_order",
        label: `Advance Paid${paymentMethod ? ` (${paymentMethod})` : ""}`,
        shortLabel: "Advance Paid",
        isPaid,
        method: paymentMethod,
        provider: "",
        uniqueId: "",
        tableName,
      };
    }
  }

  // 4. Check Direct order-level advance field
  if (order?.advance !== undefined && order?.advance !== null && Number(order.advance) > 0) {
    const rawAdvance = Number(order.advance);
    return {
      hasAdvance: true,
      advanceAmount: rawAdvance,
      advanceType: "direct",
      label: "Advance Paid",
      shortLabel: "Advance Paid",
      isPaid: true,
      method: "Advance",
      provider: "",
      uniqueId: "",
      tableName,
    };
  }

  return {
    hasAdvance: false,
    advanceAmount: 0,
    advanceType: null,
    label: "",
    shortLabel: "",
    isPaid: false,
    method: "",
    provider: "",
    uniqueId: "",
    tableName,
  };
};

export default getOrderAdvanceDetails;
